export const captcha_site_key = "6LeRM_0pAAAAALb0lsuPqVMfQ1FEJzlCOXAsPGOS";
export const captcha_secret_key = "6LeRM_0pAAAAAAhzscVynLtTTchhFPNDyswXQVGr";
export const google_api_key = "AIzaSyDzg1qShRMAL1Koj3VFQx7333ECQjxVaj8";